import { AnySchema, ValidationError } from 'yup';


export class ContractLineValidator<T> {
  private validationSchema: AnySchema;

  constructor(schema: AnySchema) {
    this.validationSchema = schema;
  }

  getErrorsAt(path: string, data: T, context?: any): string[] {
    try {
      this.validationSchema.validateSyncAt(path, data, {
        context,
        abortEarly: false,

      });
      return [];
    }
    catch (err) {
      if (err instanceof ValidationError) {
        return err.errors;
      }

      throw err;
    }
  }

  isValidAt(path: string, data: T, context?: any): boolean {
    const errors = this.getErrorsAt(path, data, context);
    const isValid = errors.length === 0;
    return isValid;
  }

  isValidContractLine(data: T, context?: any): boolean {
    return this.validationSchema.isValidSync(data, { context });
  }

  getErrors(data: T, context?: any): string[] {
    try {
      this.validationSchema.validateSync(data, {
        context,
        abortEarly: false
      });
      return [];
    }
    catch (err) {
      if (err instanceof ValidationError) {
        return err.errors;
      }

      throw err;
    }
  }
}
